module.exports = __webpack_public_path__ + "static/marcus-autograph-d86803e159413d3cca54fb7736432e13.jpg";